import { component, computed } from 'knockout-decorators'
import {
  TouristTaxState,
  type TouristTaxContent,
} from '../../state/tourist-tax'
import UserIcon from '../../../../images/icons/heroicons/user-circle.svg?raw'

import source from './template.html?raw'
import './style.css'
import { Language } from '~/utils'

@component('tourist-tax-guest', source)
export class TouristTaxGuest {
  private touristTaxState = TouristTaxState.get()
  private Locale = Language.getInstance()

  public formData: TouristTaxContent
  public index: number

  public i18n(key: string): string {
    return this.Locale.translations[key]
  }

  public userIcon = UserIcon

  constructor(params: { formData: TouristTaxContent; index: number }) {
    this.formData = params.formData
    this.index = params.index
  }

  public addGuest() {
    this.touristTaxState.addGuest(this.formData.id)
  }

  @computed
  public get canAddGuest(): boolean {
    return this.touristTaxState.canAddGuest(this.formData.id)
  }

  @computed
  public get currentQuantity(): number {
    return this.formData.guests().length
  }
  @computed
  public get ticketTypeDescription(): string {
    const offer = this.touristTaxState.cartResponse?.cart.find(
      (offer) =>
        parseInt(offer.sku) === this.formData.ticketTypeId &&
        offer.seatmapSeatId === this.formData.seatmapSeatId
    )
    return offer?.description || ''
  }

  public get ticketTypeName(): string {
    return `${this.i18n('location')} ${this.formData.id} - ${
      this.ticketTypeDescription
    }`
  }

  public getGlobalGuestIndex(localIndex: number): number {
    // Calculate global index by adding all guests from previous content items
    let globalIndex = 0
    const allContent = this.touristTaxState.content

    for (let i = 0; i < allContent.length; i++) {
      if (allContent[i].id === this.formData.id) {
        // Found our content item, add the local index
        return globalIndex + localIndex
      }
      // Add guests from previous content items
      globalIndex += allContent[i].guests().length
    }

    return localIndex // Fallback to local index if not found
  }
}
